import { createColor } from '@manakin/theme/lib/color';

const yellow = createColor('#FFECC2');

export default yellow;
